module.exports = window["MaterialUI"].DialogActions;